import React from 'react';
import { Img } from 'react-image';

interface Props {}

const NoChallengesFound = ({}: Props) => {
	// only return true if user has not completed screening round and is not a masai student
	return (
		<>
			<div className="flex flex-col items-center justify-center">
				<div className="px-8">
					<div className="flex justify-center">
						<Img
							loading="lazy"
							src="/assets/noApplicationsEmptyState.svg"
							alt="noApplicationsEmptyState"
							width="160"
							height="160"
						/>
					</div>

					<div className="text-center mt-4 text-base font-medium">Stay tuned for exciting coding challenges!</div>
					<div className="text-center mt-2 text-sm font-normal text-gray-600 dark:text-[#C7C9D9]">
						There are currently no coding challenges available, but keep an eye out for upcoming challenges.
					</div>
				</div>
			</div>
		</>
	);
};

export default NoChallengesFound;
